
import { useCookies } from "vue3-cookies";
import axios from 'axios'

const { cookies } = useCookies();

/*univ*/
/*axios.defaults.baseURL = "https://mtaskino.srbiau.ac.ir/api/";*/
 
/*dssco*/
/*axios.defaults.baseURL = "https://mobile.dssnovinit.com/api/";*/

/*raazGroup*/
//axios.defaults.baseURL = "https://mraazgroup.taskinoapp.com/api/";

/*local*/ 
/*axios.defaults.baseURL = "http://localhost:5000/api/";*/

/*Karnegasht api*/
/*image icon config*/
/*E: \Sources\Repos\TaskApi\TaskApp.VueCore\clientTaskApp\clientTaskApp\android\app\src\main*/
axios.defaults.baseURL = "https://mobile.karnegasht.com/api/";


/*icon file*/
/*E: \Sources\Repos\TaskApi\TaskApp.VueCore\clientTaskApp\clientTaskApp\public\assets\images\taskinoIcon - 02.png*/

/*taskonline new api*/
/*axios.defaults.baseURL = "https://mobile.taskinoapp.com/api/";*/

/*taskonline hamyariSemnan api*/
/*axios.defaults.baseURL = "https://mobile.dsh-hamyarisem.ir/api/";*/


////taskonline
/*axios.defaults.baseURL = "https://mtask.dssnovinit.com/api/";*/

/*Decorabo*/
/*axios.defaults.baseURL = "https://mdecorabo.taskinoapp.com/api/";*/

/*vazin*/
/*axios.defaults.baseURL = "https://mvazin.sardchal.com/api/";*/

/*aron*/
/*axios.defaults.baseURL = "https://maron.sardchal.com/api/";*/

/*Forge*/
/*axios.defaults.baseURL = "https://mforge.taskinoapp.com/api/";*/

/*media shetab*/
/*axios.defaults.baseURL = "https://mmedia.taskinoapp.com/api/";*/

/*arsan faraz seman*/
/*axios.defaults.baseURL = "https://marsan.taskinoapp.com/api/";*/


/*Alborzw*/
//axios.defaults.baseURL = "https://malborzw.taskinoapp.com/api/";

/*Arin sannat aseya*/
/*axios.defaults.baseURL = "https://mavrin.taskinoapp.com/api/";*/

/*Tabriz-shahrdari*/
/*axios.defaults.baseURL = "https://mtask.tabriz.ir/api/";*/

/*fafait localserver سرور فافا*/
/*axios.defaults.baseURL = "https://merp.fafait.net/api/";*/

/*SaPost.ir localserver سرور صاپست*/
/*axios.defaults.baseURL = "https://merp.sapost.ir/api/";*/

/*ista  ایستا*/
//axios.defaults.baseURL = "https://mIsta.dssnovinit.com/api/";



axios.interceptors.request.use(
    (config: any) => {
        let info2 = cookies.get('eInfo2');
        if (info2 == null || info2.trim().length < 1) {
            info2 = "";
        }
        const token = "Bearer " + cookies.get('eInfo1') + info2
        if (token) {
            config.headers["Authorization"] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axios;